module.exports = __webpack_public_path__ + "img/youzan_sj.8e26eb03.png";